<template>
  <div class="container-fluid container-fluid rounded-4 contenedor-principal">
    <div class="grid-observaciones px-1">
      <!-- Rejilla -->
      <operaciones-agua-grid-detail ref="grid" :template-data="templateData"/>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';
import OperacionesAguaGridDetail from '@/components/operaciones-agua/OperacionesAguaGridDetail.vue';
import { type DetailOperacionAguaModel } from '@/.shared/.api';
import { useApi } from '@/.shared/.api/integration';
import { useIntl } from '@/.shared/services/i18n';

const props = defineProps({
  model: Object as () => DetailOperacionAguaModel
});

const api = useApi();
const intl = useIntl();
const observacion = ref('');
const grid = ref<InstanceType<typeof OperacionesAguaGridDetail>>();

const templateData = computed(() => {
  return {
    key: props.model?.Id,
    data: undefined
  };
})

</script>

<style lang="scss" scoped>

@import "@styles/_sharedvars.scss";

.grid-observaciones {
  flex-grow: 1; 
  max-height: 80%; 
  overflow: auto; 
}

.grid-observaciones :deep(.dx-datagrid) {
  max-height: calc(479px - 115px);
}

</style>